// Slick JS
import 'slick-carousel/slick/slick.min';

if( $('html').attr('dir') === 'rtl' || $('body').hasClass('rtl') ) {
    //-------------------------- Arabic
    // Events timeline SLIDER on small screens only(below lg)
    if(window.outerWidth > 991){
        if($('#events-timeline').hasClass('slick-initialized')) {
            $('#events-timeline').slick('unslick');
        }
    }else{
        $('#events-timeline').slick({
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
            infinite: false,
            centerMode: false,
            variableWidth: true,
            useTransform: false,
            useCss: false,
            mobileFirst: true,
            swipeToSlide: true,
            rtl: true, 
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    }

    $(window).on('resize', (e) => {
        if(window.outerWidth > 991){
            if($('#events-timeline').hasClass('slick-initialized')) {
                $('#events-timeline').slick('unslick');
            }
        }else{
            $('#events-timeline').slick({
                dots: false,
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: true,
                infinite: false,
                centerMode: false,
                variableWidth: true,
                useTransform: false,
                useCss: false,
                mobileFirst: true,
                swipeToSlide: true,
                rtl: true, 
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

} else {
    //-------------------------- English
    // Events timeline SLIDER on small screens only(below lg)
    if(window.outerWidth > 991){
        if($('#events-timeline').hasClass('slick-initialized')) {
            $('#events-timeline').slick('unslick');
        }
    }else{
        $('#events-timeline').slick({
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
            infinite: false,
            centerMode: false,
            variableWidth: true,
            useTransform: false,
            useCss: false,
            mobileFirst: true,
            swipeToSlide: true, 
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    }

    $(window).on('resize', (e) => {
        if(window.outerWidth > 991){
            if($('#events-timeline').hasClass('slick-initialized')) {
                $('#events-timeline').slick('unslick');
            }
        }else{
            $('#events-timeline').slick({
                dots: false,
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: true,
                infinite: false,
                centerMode: false,
                variableWidth: true,
                useTransform: false,
                useCss: false,
                mobileFirst: true,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });
}
